import { TruthyNumberArrayParam } from "@src/utils/queryParams";
import { useCallback } from "react";
import {
  BooleanParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

export type HrisSearchFilters = {
  searchValue: string | undefined;
  locationIds: number[];
  roleIds: number[];
  inviteStatus: boolean | undefined;
};

export type SetHrisSearchFiltersType = (filters: HrisSearchFilters) => void;

type UpdateHrisSearchFiltersType = (
  filters: Partial<HrisSearchFilters>,
) => void;

const EMPTY_FILTERS = {
  searchValue: undefined,
  locationIds: [],
  roleIds: [],
  inviteStatus: undefined,
};

export const useHrisSearchFilters = (): {
  hrisSearchFilters: HrisSearchFilters;
  setHrisSearchFilters: SetHrisSearchFiltersType;
  updateHrisSearchFilters: UpdateHrisSearchFiltersType;
  clearHrisSearchFilters: () => void;
} => {
  const [hrisSearchFilters, updateHrisSearchFilters] = useQueryParams({
    searchValue: withDefault(StringParam, undefined),
    locationIds: withDefault(TruthyNumberArrayParam, []),
    roleIds: withDefault(TruthyNumberArrayParam, []),
    inviteStatus: withDefault(BooleanParam, undefined),
  });

  const setHrisSearchFilters = useCallback(
    (filters: HrisSearchFilters) => {
      updateHrisSearchFilters(filters);
    },
    [updateHrisSearchFilters],
  );

  const clearHrisSearchFilters = useCallback(() => {
    updateHrisSearchFilters(EMPTY_FILTERS);
  }, [updateHrisSearchFilters]);

  return {
    hrisSearchFilters,
    setHrisSearchFilters,
    updateHrisSearchFilters,
    clearHrisSearchFilters,
  };
};
